<a *ngIf="record['imported_rows']" matTooltip="{{ 'download_imported_rows' | translate }}" (click)="download('success')" class="actions text-success pointer">
  <fa-icon [icon]="['fas', 'file-download']"></fa-icon>
</a>
<a *ngIf="record['imported_rows'] == 0 && record['erroneous_rows']" matTooltip="{{ 'download_erroneous_rows' | translate }}" (click)="download('errors')" class="actions text-danger pointer">
  <fa-icon [icon]="['fas', 'file-download']"></fa-icon>
</a>